import { render, staticRenderFns } from "./inputFile.vue?vue&type=template&id=c2ffb532&scoped=true&"
import script from "./inputFile.vue?vue&type=script&lang=js&"
export * from "./inputFile.vue?vue&type=script&lang=js&"
import style0 from "./inputFile.vue?vue&type=style&index=0&id=c2ffb532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ffb532",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VFileInput,VIcon})
